module.exports = __webpack_public_path__ + "bnbproject/img/bg.eb23a28e.png";